var r,i={isFirefox:(r=window.navigator.userAgent,/(Firefox|Focus|FxiOS)\//i.test(r)),isSafari:function(){var r=window.navigator.userAgent;return/^((?!chrome|android|mqbhd|MQQBrowser).)*safari/i.test(r)}()};export{i as U};
